export default "__VITE_ASSET__DCbWsTz1__"